import { modelComposition } from 'trait/composition'

const descriptor = 'model::ticket::closure'

export default modelComposition(descriptor)
